import React, { FC, useMemo } from 'react';
import {Text} from "@keyslabor/shared/ui";
import {CalendarIcon, LocationIcon} from "@/assets/offer";
import {useTranslation} from "react-i18next";
import { Offer} from "@/api/types.ts";

const InpersonInterviewDetails: FC<{data: Offer}> = ({data}) => {
    const {t} = useTranslation('confirmation')

    const [date, time] = useMemo(() => {
        if (!data?.in_person_interview_date) return ['N/A', ''];
        const dateObj = new Date(data.in_person_interview_date);
        const date = dateObj.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric'
        });
        const time = dateObj.toLocaleTimeString('en-US', {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        });
        return [date, time] as const;
    }, [data?.in_person_interview_date]);

    return (
        <div className="flex flex-col mt-[70px] justify-self-start px-5 space-y-5">
            <div className="flex items-start">
                <CalendarIcon className="flex-shrink-0" />
                <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px" maxWidth="50%">
                    {t('inPersonInterview')}
                </Text>
                <Text>
                    {date}<br/>{time}
                </Text>
            </div>
            <div className="flex items-center">
                <LocationIcon className="flex-shrink-0" />
                <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                    {t('location')}
                </Text>
                <Text>{data?.property_address}</Text>
            </div>
            <div className="flex items-center">
                <span className="size-4"/>
                <Text ml="12px" fontWeight="700" fontSize="16px" color="black" mr="4px">
                    {t('managerName')}
                </Text>
                <Text>{data?.manager_name}</Text>
            </div>
        </div>
    );
};

export default InpersonInterviewDetails;